"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { ArtistActiveSubmissionContent } from "./ArtistActiveSubmissionContent";
import { ArtistWinningArtworksContent } from "./ArtistWinningArtworksContent";
import { ArtistPreviewModalHeader } from "./ArtistPreviewModalHeader";
import { ArtistPreviewModalTabs } from "./ArtistPreviewModalTabs";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ModalTab } from "./ArtistPreviewModal";
import { useCompactMode } from "@/contexts/CompactModeContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { getSubmissionCount, getTrophyArtworkCount } from "@/helpers/artist-activity.helpers";
interface ArtistPreviewModalContentProps {
  readonly user: ApiProfileMin;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly isApp?: boolean | undefined;
  readonly activeTab: ModalTab;
  readonly onTabChange: (tab: ModalTab) => void;
  readonly hasTrophyArtworks: boolean;
}
export const ArtistPreviewModalContent: React.FC<ArtistPreviewModalContentProps> = t0 => {
  const $ = _c(45);
  const {
    user,
    isOpen,
    onClose,
    isApp: t1,
    activeTab,
    onTabChange,
    hasTrophyArtworks
  } = t0;
  const isApp = t1 === undefined ? false : t1;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const compact = useCompactMode();
  const isSmallScreen = useMediaQuery("(max-width: 1023px)");
  const submissionCount = getSubmissionCount(user);
  let t2;
  if ($[0] !== user) {
    t2 = getTrophyArtworkCount(user);
    $[0] = user;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trophyCount = t2;
  const hasActiveSubmissions = submissionCount > 0;
  const showTabs = hasActiveSubmissions && hasTrophyArtworks;
  let currentContentType;
  if (showTabs) {
    currentContentType = activeTab;
  } else {
    if (hasTrophyArtworks) {
      currentContentType = "winners";
    } else {
      currentContentType = "active";
    }
  }
  let t3;
  if ($[2] !== compact || $[3] !== isSmallScreen || $[4] !== onClose || $[5] !== pathname || $[6] !== router || $[7] !== searchParams) {
    t3 = drop => {
      if (searchParams) {
        const params = new URLSearchParams(searchParams.toString());
        params.set("drop", drop.id);
        router.push(`${pathname}?${params.toString()}`);
      }
      if (compact && isSmallScreen && globalThis.window !== undefined) {
        globalThis.window.dispatchEvent(new CustomEvent("single-drop:close-chat"));
      }
      onClose();
    };
    $[2] = compact;
    $[3] = isSmallScreen;
    $[4] = onClose;
    $[5] = pathname;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleDropClick = t3;
  let t4;
  if ($[9] !== currentContentType) {
    t4 = currentContentType === "winners" && <><div className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-12 tw-bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0)_70%)]" /><div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-backdrop-blur-[1px]" /></>;
    $[9] = currentContentType;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== currentContentType || $[12] !== isApp || $[13] !== onClose || $[14] !== submissionCount || $[15] !== trophyCount || $[16] !== user) {
    t5 = <ArtistPreviewModalHeader user={user} onClose={onClose} isApp={isApp} currentContentType={currentContentType} submissionCount={submissionCount} trophyCount={trophyCount} />;
    $[11] = currentContentType;
    $[12] = isApp;
    $[13] = onClose;
    $[14] = submissionCount;
    $[15] = trophyCount;
    $[16] = user;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== activeTab || $[19] !== onTabChange || $[20] !== showTabs) {
    t6 = showTabs && <ArtistPreviewModalTabs activeTab={activeTab} onTabChange={onTabChange} />;
    $[18] = activeTab;
    $[19] = onTabChange;
    $[20] = showTabs;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  bb0: {
    if (showTabs) {
      let t8;
      if ($[22] !== activeTab || $[23] !== handleDropClick || $[24] !== isApp || $[25] !== isOpen || $[26] !== onClose || $[27] !== user) {
        t8 = activeTab === "active" ? <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} /> : <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[22] = activeTab;
        $[23] = handleDropClick;
        $[24] = isApp;
        $[25] = isOpen;
        $[26] = onClose;
        $[27] = user;
        $[28] = t8;
      } else {
        t8 = $[28];
      }
      t7 = t8;
      break bb0;
    }
    if (hasTrophyArtworks) {
      let t8;
      if ($[29] !== handleDropClick || $[30] !== isOpen || $[31] !== user) {
        t8 = <ArtistWinningArtworksContent user={user} isOpen={isOpen} onDropClick={handleDropClick} />;
        $[29] = handleDropClick;
        $[30] = isOpen;
        $[31] = user;
        $[32] = t8;
      } else {
        t8 = $[32];
      }
      t7 = t8;
      break bb0;
    }
    let t8;
    if ($[33] !== isApp || $[34] !== isOpen || $[35] !== onClose || $[36] !== user) {
      t8 = <ArtistActiveSubmissionContent user={user} isOpen={isOpen} onClose={onClose} isApp={isApp} />;
      $[33] = isApp;
      $[34] = isOpen;
      $[35] = onClose;
      $[36] = user;
      $[37] = t8;
    } else {
      t8 = $[37];
    }
    t7 = t8;
  }
  let t8;
  if ($[38] !== t6 || $[39] !== t7) {
    t8 = <div className="tw-relative tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300">{t6}{t7}</div>;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== t4 || $[42] !== t5 || $[43] !== t8) {
    t9 = <div className="tailwind-scope tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-white/5 tw-bg-[#0E1012] tw-shadow-[0_10px_40px_rgba(0,0,0,0.55)]">{t4}{t5}{t8}</div>;
    $[41] = t4;
    $[42] = t5;
    $[43] = t8;
    $[44] = t9;
  } else {
    t9 = $[44];
  }
  return t9;
};